import React from 'react';

/**
 * TestimonialCard — editorial blockquote card.
 * Elegant typographic initials replace cartoon avatars.
 */
const initialsOf = (name = '') =>
  name
    .split(/\s+/)
    .map((n) => n[0])
    .filter(Boolean)
    .slice(0, 2)
    .join('')
    .toUpperCase();

const TestimonialCard = ({ testimonial, variant = 'default' }) => {
  const isFeature = variant === 'feature';

  return (
    <figure
      className={`relative bg-white border border-brand-hairline p-8 md:p-10 flex flex-col h-full ${
        isFeature ? 'md:p-12' : ''
      }`}
      data-testid={`testimonial-${testimonial.id}`}
    >
      <span
        aria-hidden
        className="font-display text-[120px] leading-none text-brand-oxford/10 absolute -top-4 left-6 select-none pointer-events-none"
      >
        “
      </span>

      <blockquote
        className={`relative font-display text-brand-oxford leading-[1.28] flex-1 ${
          isFeature ? 'text-2xl md:text-3xl' : 'text-xl md:text-[22px]'
        }`}
      >
        {testimonial.text}
      </blockquote>

      <figcaption className="mt-8 flex items-center gap-4 pt-6 border-t border-brand-hairline">
        <div
          aria-hidden
          className="w-11 h-11 shrink-0 border border-brand-oxford flex items-center justify-center font-display text-lg text-brand-oxford"
        >
          {initialsOf(testimonial.name)}
        </div>
        <div className="min-w-0">
          <div className="text-sm font-semibold text-brand-oxford truncate">{testimonial.name}</div>
          <div className="text-[12px] text-brand-slate truncate">
            {testimonial.role}
            {testimonial.company ? ` · ${testimonial.company}` : ''}
          </div>
          {testimonial.location && (
            <div className="text-[11px] tracking-[0.14em] uppercase text-brand-slate/70 mt-0.5">
              {testimonial.location}
            </div>
          )}
        </div>
      </figcaption>
    </figure>
  );
};

export default TestimonialCard;
